import React from "react";
import { ArrowRight, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-introduction" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden ![padding:75px_0px_0px_0px] !bg-[url(https://humble-drake.10web.cloud/wp-content/uploads/2026/02/signature_journeys_hero.webp)] !bg-[url(https://humble-drake.10web.cloud/wp-content/uploads/2026/02/Chen.webp)] !bg-[url(https://humble-drake.10web.cloud/wp-content/uploads/2026/02/signature_journeys_hero.webp)]">
      {}
      <div className="absolute inset-0 w-full h-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553131/img/israeli_landscape_negev.png)] bg-cover bg-center bg-fixed z-0" />

      {}
      <div className="absolute inset-0 w-full h-full bg-[rgba(1,49,131,0.6)] z-0" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <h1 className="font-heading font-bold text-5xl md:text-7xl tracking-tighter text-white max-w-4xl leading-[1.1] drop-shadow-lg">
          Discover the Untold Stories of the Land
        </h1>

        {}
        <p className="font-sans font-light italic text-xl md:text-2xl text-white/90 mt-6 max-w-2xl drop-shadow-md leading-[1.6]">
          A journey through time, culture, and the breathtaking vistas of the Galilee.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-6 mt-12 w-full justify-center">
          <Button asChild variant="outline" className="h-14 px-8 text-lg border border-white bg-transparent text-white hover:bg-white hover:text-[#013183] transition-all duration-400 ease-in-out rounded-none uppercase tracking-widest font-sans">
            
          </Button>

          <Button asChild variant="outline" className="h-14 px-8 text-lg border border-white bg-transparent text-white hover:bg-white hover:text-[#013183] transition-all duration-400 ease-in-out rounded-none uppercase tracking-widest font-sans">
            
          </Button>
        </div>
      </div>
    </section>;
}